import React, { useState } from 'react'
import Invoice from '@assets/img/reservation/invoice.svg'
import ErrorIcon from '@assets/img/reservation/error-icon.svg'
import classNames from 'classnames'
import { useReservationContext } from './ReservationContext'

const InvoiceDetails = ({}) => {
    const { form, handleChange, errors, t } = useReservationContext()

    return (
        <div className="trip-reservation__invoice">
            <div className="trip-reservation__small-heading trip-reservation__small-heading--inovice-details">
                <img src={Invoice} alt="invoice" />
                {t('invoice-data')}
            </div>
            <div className="trip-reservation__invoice-radios">
                <label className="trip-reservation__invoice-type">
                    <input
                        type="radio"
                        value="person"
                        name="invoiceType"
                        checked={!form.invoiceType || form.invoiceType === 'person'}
                        onChange={handleChange}
                    />
                    <span className="trip-reservation__payment-method-radio-checkmark"></span>
                    <b>{t('invoice-no-vat')}</b>
                </label>
                <label className="trip-reservation__invoice-type ">
                    <input
                        type="radio"
                        value="company"
                        name="invoiceType"
                        checked={form.invoiceType === 'company'}
                        onChange={handleChange}
                    />
                    <span className="trip-reservation__payment-method-radio-checkmark"></span>
                    <b>{t('invoice-with-vat')}</b>
                </label>
            </div>
            <div className="trip-reservation__invoice-form">
                <label
                    className={classNames('trip-reservation__label', {
                        'trip-reservation__label--1-4': form.invoiceType === 'company',
                        'trip-reservation__label--full': form.invoiceType !== 'company',
                    })}
                >
                    {form.invoiceType === 'company' ? t('company-name') : t('full-name')}
                    <input
                        placeholder={form.invoiceType === 'company' ? t('enter-company-name') : t('enter-full-name')}
                        value={form.invoiceDisplayName}
                        onChange={handleChange}
                        name="invoiceDisplayName"
                        className={classNames('trip-reservation__input', {
                            'trip-reservation__input--error': errors.email,
                        })}
                    />
                    {errors.invoiceDisplayName ? (
                        <>
                            <div className="trip-reservation__error">{errors.invoiceDisplayName[0]}</div>
                            <img className="trip-reservation__error-icon" src={ErrorIcon} alt="" />
                        </>
                    ) : null}
                </label>
                {form.invoiceType === 'company' ? (
                    <label className="trip-reservation__label trip-reservation__label--4-5">
                        NIP
                        <input
                            placeholder="Podaj NIP"
                            value={form.invoiceNip}
                            onChange={handleChange}
                            name="invoiceNip"
                            className={classNames('trip-reservation__input', {
                                'trip-reservation__input--error': errors.email,
                            })}
                        />
                        {errors.invoiceNip ? (
                            <>
                                <div className="trip-reservation__error">{errors.invoiceNip[0]}</div>
                                <img className="trip-reservation__error-icon" src={ErrorIcon} alt="" />
                            </>
                        ) : null}
                    </label>
                ) : null}
                <label className="trip-reservation__label trip-reservation__label--1-3">
                    {t('street')}
                    <input
                        placeholder={t('enter-street')}
                        value={form.invoiceStreet}
                        onChange={handleChange}
                        name="invoiceStreet"
                        className={classNames('trip-reservation__input', {
                            'trip-reservation__input--error': errors.email,
                        })}
                    />
                    {errors.invoiceStreet ? (
                        <>
                            <div className="trip-reservation__error">{errors.invoiceStreet[0]}</div>
                            <img className="trip-reservation__error-icon" src={ErrorIcon} alt="" />
                        </>
                    ) : null}
                </label>
                <label className="trip-reservation__label trip-reservation__label--3-4">
                    {t('building-number')}
                    <input
                        placeholder={t('enter-building-number')}
                        value={form.invoiceBuildingNumber}
                        onChange={handleChange}
                        name="invoiceBuildingNumber"
                        className={classNames('trip-reservation__input', {
                            'trip-reservation__input--error': errors.email,
                        })}
                    />
                    {errors.invoiceBuildingNumber ? (
                        <>
                            <div className="trip-reservation__error">{errors.invoiceBuildingNumber[0]}</div>
                            <img className="trip-reservation__error-icon" src={ErrorIcon} alt="" />
                        </>
                    ) : null}
                </label>
                <label className="trip-reservation__label trip-reservation__label--4-5">
                    {t('local-number')}
                    <input
                        placeholder={t('enter-local')}
                        value={form.invoiceLocalNumber}
                        onChange={handleChange}
                        name="invoiceLocalNumber"
                        className={classNames('trip-reservation__input', {
                            'trip-reservation__input--error': errors.email,
                        })}
                    />
                    {errors.invoiceLocalNumber ? (
                        <>
                            <div className="trip-reservation__error">{errors.invoiceLocalNumber[0]}</div>
                            <img className="trip-reservation__error-icon" src={ErrorIcon} alt="" />
                        </>
                    ) : null}
                </label>
                <label className="trip-reservation__label trip-reservation__label--1-3">
                    {t('city')}
                    <input
                        placeholder={t('enter-city')}
                        value={form.invoiceCity}
                        onChange={handleChange}
                        name="invoiceCity"
                        className={classNames('trip-reservation__input', {
                            'trip-reservation__input--error': errors.email,
                        })}
                    />
                    {errors.invoiceCity ? (
                        <>
                            <div className="trip-reservation__error">{errors.invoiceCity[0]}</div>
                            <img className="trip-reservation__error-icon" src={ErrorIcon} alt="" />
                        </>
                    ) : null}
                </label>
                <label className="trip-reservation__label trip-reservation__label--3-4">
                    {t('postal-code')}
                    <input
                        placeholder={t('enter-postal-code')}
                        value={form.invoicePostcode}
                        onChange={handleChange}
                        name="invoicePostcode"
                        className={classNames('trip-reservation__input', {
                            'trip-reservation__input--error': errors.email,
                        })}
                    />
                    {errors.invoicePostcode ? (
                        <>
                            <div className="trip-reservation__error">{errors.invoicePostcode[0]}</div>
                            <img className="trip-reservation__error-icon" src={ErrorIcon} alt="" />
                        </>
                    ) : null}
                </label>
                <label className="trip-reservation__label trip-reservation__label--4-5">
                    {t('country')}
                    <input
                        placeholder={t('enter-country')}
                        value={form.invoiceCountry}
                        onChange={handleChange}
                        name="invoiceCountry"
                        className={classNames('trip-reservation__input', {
                            'trip-reservation__input--error': errors.email,
                        })}
                    />
                    {errors.invoiceCountry ? (
                        <>
                            <div className="trip-reservation__error">{errors.invoiceCountry[0]}</div>
                            <img className="trip-reservation__error-icon" src={ErrorIcon} alt="" />
                        </>
                    ) : null}
                </label>
            </div>
            <div className="trip-reservation__invoice-desc">{t('invoice-info-note')}</div>
        </div>
    )
}

export default InvoiceDetails
